import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './iso-standards-ai-grc-ai-governance-risk-compliance.css'

const ISOStandardsAIGRCAIGovernanceRiskCompliance = (props) => {
  return (
    <div className="iso-standards-aigrcai-governance-risk-compliance-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="ISO-Standards-AI-GRC-AI-Governance-Risk-Compliance - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/iso-standards-ai-grc-ai-governance-risk-compliance"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="iso-standards-aigrcai-governance-risk-compliance-container2">
        <div className="iso-standards-aigrcai-governance-risk-compliance-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
* {
  animation-duration: 0.01ms !important;
  transition-duration: 0.01ms !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="hero-section iso-standards---ai-grc--ai-governance--risk---compliance--hero-section">
        <div className="hero-media">
          <img
            alt="AI technology and digital network representing governance"
            src="https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-bg-image"
          />
          <div className="iso-standards---ai-grc--ai-governance--risk---compliance--hero-overlay hero-overlay"></div>
        </div>
        <div className="iso-standards---ai-grc--ai-governance--risk---compliance--hero-content hero-content">
          <div className="iso-standards---ai-grc--ai-governance--risk---compliance--hero-content-inner">
            <div className="iso-standards---ai-grc--ai-governance--risk---compliance--hero-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>Enterprise-Grade Compliance</span>
            </div>
            <h1 className="hero-title iso-standards---ai-grc--ai-governance--risk---compliance--hero-title">
              ISO Standards
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </h1>
            <p className="iso-standards---ai-grc--ai-governance--risk---compliance--hero-subtitle hero-subtitle">
              Align your systems with global ISO standards. Our comprehensive
              GRC framework ensures regulatory compliance, risk mitigation, and
              governance 
            </p>
            <div className="hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request AI GRC Assessment</span>
                </div>
              </a>
              <a href="#methodology">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Our Methodology</span>
                  
                </div>
              </a>
            </div>
            <div className="hero-trust-indicators">
              <div className="iso-standards---ai-grc--ai-governance--risk---compliance--trust-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>ISO Certified</span>
              </div>
              <div className="iso-standards---ai-grc--ai-governance--risk---compliance--trust-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span> Risk Specialists</span>
              </div>
              <div className="iso-standards---ai-grc--ai-governance--risk---compliance--trust-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Global Compliance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iso-standards-section">
        <div className="iso-standards-container">
          <div className="iso-standards-header">
            <h2 className="section-title">
              ISO Standards Mapping &amp; Integration
            </h2>
            <p className="section-subtitle">
              Comprehensive alignment with international standards for
              information security management
            </p>
          </div>
          <div className="iso-standards-grid">
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 27001</h3>
              <p className="iso-standard-description">
                Information Security Management Systems aligned with AI risk
                controls and data protection requirements for secure AI
                operations.
              </p>
            </div>
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 27701</h3>
              <p className="iso-standard-description">
                Privacy Information Management extending ISO 27001 for GDPR and
                AI data processing compliance with privacy-by-design principles.
              </p>
            </div>
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 22301</h3>
              <p className="iso-standard-description">
                Business Continuity Management ensuring AI system resilience,
                disaster recovery, and operational continuity under adverse
                conditions.
              </p>
            </div>
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 42001</h3>
              <p className="iso-standard-description">
                AI Management System standard providing governance framework for
                responsible development, deployment, and monitoring of AI
                systems.
              </p>
            </div>
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 31000</h3>
              <p className="iso-standard-description">
                Risk Management principles integrated with AI risk
                identification, assessment, and treatment for comprehensive
                enterprise risk strategy.
              </p>
            </div>
            <div className="iso-standard-card">
              <div className="iso-standard-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iso-standard-title">ISO 27005</h3>
              <p className="iso-standard-description">
                Information Security Risk Management tailored for AI-specific
                threats including model poisoning, adversarial attacks, and data
                leakage.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="ai-grc-approach-section">
        <div className="ai-grc-approach-container">
          <div className="ai-grc-approach-header">
            <h2 className="section-title">
              {' '}
              Governance, Risk &amp; Compliance Approach
            </h2>
            <p className="section-subtitle">
              Tailored enterprise framework balancing innovation with regulatory
              compliance
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
          <div className="ai-grc-approach-grid">
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Governance Framework</h3>
              <p className="ai-grc-approach-description">
                Establish information security governance structures, including
                defined roles, decision-making authorities, accountability
                mechanisms, and policy frameworks aligned with organizational
                objectives and regulatory requirements.
              </p>
            </div>
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Risk Assessment</h3>
              <p className="ai-grc-approach-description">
                Comprehensive identification and assessment of information
                security risks, including data confidentiality, integrity and
                availability threats, third-party dependencies, system
                weaknesses, and emerging technology
              </p>
            </div>
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Compliance Mapping</h3>
              <p className="ai-grc-approach-description">
                Map information systems and operational processes to applicable
                regulatory and legal requirements, including GDPR, CCPA,
                sector-specific regulations, and relevant industry standards,
                ensuring consistent compliance across jurisdictions.
              </p>
            </div>
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Control Implementation</h3>
              <p className="ai-grc-approach-description">
                Design and implement technical, administrative, and physical
                information security controls, including access management,
                system monitoring, logging, and incident response, to protect
                information systems and support ISO objectives.
              </p>
            </div>
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Continuous Monitoring</h3>
              <p className="ai-grc-approach-description">
                Establish continuous monitoring and measurement mechanisms,
                including dashboards, key performance indicators (KPIs),
                automated alerts for control deviations, and periodic compliance
                assessments to sustain an effective GRC and ISO posture.
              </p>
            </div>
            <div className="ai-grc-approach-card">
              <div className="ai-grc-approach-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ai-grc-approach-title">Audit &amp; Reporting</h3>
              <p className="ai-grc-approach-description">
                Prepare audit-ready documentation, executive reporting packages,
                regulatory submissions, and stakeholder communications
                demonstrating compliance and risk management effectiveness.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="methodology" className="assessment-methodology-section">
        <div className="assessment-methodology-container">
          <div className="assessment-methodology-header">
            <h2 className="section-title">Assessment Methodology</h2>
            <p className="section-subtitle">
              Structured approach to evaluate risk posture, identify control
              gaps, and ensure regulatory compliance
            </p>
          </div>
          <div className="assessment-methodology-steps">
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>01</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">
                  Asset Inventory &amp; Classification
                </h3>
                <p className="assessment-step-description">
                  Establish and maintain a comprehensive inventory of
                  information assets, including systems, applications, data, and
                  supporting infrastructure. Classify assets based on
                  confidentiality, integrity, and availability (CIA)
                  requirements to support risk-based control selection.
                </p>
              </div>
            </div>
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>02</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">Risk Assesment</h3>
                <p className="assessment-step-description">
                  Identify, analyze, and evaluate information security risks
                  considering threat sources, vulnerabilities, likelihood, and
                  business impact. Assess risks using a defined risk methodology
                  aligned with organizational risk appetite.
                </p>
              </div>
            </div>
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>03</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">
                  Control Design and Effectiveness Assesment
                </h3>
                <p className="assessment-step-description">
                  Evaluate the design and operating effectiveness of information
                  security controls against ISO/IEC 27001 Annex A controls and
                  applicable regulatory requirements. Validate technical,
                  administrative, and physical controls through evidence review
                  and testing.
                </p>
              </div>
            </div>
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>04</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">
                  Compliance Gap Analysis
                </h3>
                <p className="assessment-step-description">
                  Assess compliance with applicable legal, regulatory, and
                  contractual requirements such as data protection laws, sector
                  regulations, and internal policies. Identify compliance gaps
                  and document evidence to support audit and certification
                  readiness.
                </p>
              </div>
            </div>
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>05</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">
                  Risk Treatment &amp; Remediation Planning
                </h3>
                <p className="assessment-step-description">
                  Develop and maintain risk treatment plans outlining corrective
                  actions, responsible owners, timelines, and acceptance
                  criteria. Ensure risks are mitigated, transferred, accepted,
                  or avoided in line with the ISMS risk treatment strategy.
                </p>
              </div>
            </div>
            <div className="assessment-step">
              <div className="assessment-step-number">
                <span>06</span>
              </div>
              <div className="assessment-step-content">
                <h3 className="assessment-step-title">
                  Executive Reporting &amp; Validation
                </h3>
                <p className="assessment-step-description">
                  Provide management with structured reporting including risk
                  posture, control status, and remediation progress. Support
                  management review, validation of corrective actions, and
                  continuous improvement of the ISO standard.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iso-standards---ai-grc--ai-governance--risk---compliance--deliverables-section">
        <div className="deliverables-container">
          <div className="deliverables-header">
            <h2 className="section-title">
              Comprehensive Deliverables Package
            </h2>
            <p className="section-subtitle">
              Actionable artifacts to drive GRC program maturity and regulatory
              compliance
            </p>
          </div>
          <div className="iso-standards---ai-grc--ai-governance--risk---compliance--deliverables-grid">
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">Gap Analysis Report</h3>
              <p className="deliverable-description">
                Detailed assessment of current GRC posture against ISO standards
                and regulatory requirements with prioritized findings and risk
                ratings.
              </p>
            </div>
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">Remediation Roadmap</h3>
              <p className="deliverable-description">
                Multi-phase implementation plan with timelines, resource
                requirements, dependencies, and success criteria for closing
                compliance gaps.
              </p>
            </div>
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">Policy Templates</h3>
              <p className="deliverable-description">
                Ready-to-customize governance policies, standards, and
                procedures aligned with ISO frameworks and industry best
                practices.
              </p>
            </div>
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">
                Control Design Documentation
              </h3>
              <p className="deliverable-description">
                Technical and administrative control specifications mapped to
                ISO requirements with implementation guidance and test
                procedures.
              </p>
            </div>
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">Risk Register</h3>
              <p className="deliverable-description">
                Comprehensive AI risk inventory with threat scenarios, impact
                assessments, mitigation strategies, and residual risk acceptance
                documentation.
              </p>
            </div>
            <div className="deliverable-card">
              <div className="deliverable-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-title">Compliance Matrix</h3>
              <p className="deliverable-description">
                Crosswalk mapping AI operations to applicable regulations, ISO
                standards, and contractual obligations with evidence of
                compliance.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="compliance-timeline-section">
        <div className="compliance-timeline-wrapper">
          <div className="compliance-timeline-header">
            <h2 className="section-title">ISO Standards Crosswalk</h2>
          </div>
          <div className="compliance-timeline-scroll">
            <div className="compliance-timeline">
              <div className="compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">
                    ISO 27001 Alignment
                  </h3>
                  <p className="compliance-timeline-description">
                    Establish a robust ISMS to protect information assets
                    through risk assessment, access control, and secure system
                    operations aligned with business objectives.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>ISMS Foundation</span>
                    </li>
                    <li>
                      <span>Risk Assessment</span>
                    </li>
                    <li>
                      <span>Access Control</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="iso-standards-aigrcai-governance-risk-compliance-thq-compliance-timeline-item-elm2 compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">ISO 22301 BCMS </h3>
                  <p className="compliance-timeline-description">
                    Ensure operational resilience by implementing business
                    continuity planning, impact analysis, and recovery
                    strategies to minimize disruption.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>BCMS framework </span>
                    </li>
                    <li>
                      <span>BIA</span>
                    </li>
                    <li>
                      <span>Continuity</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">ISO 27018</h3>
                  <p className="compliance-timeline-description">
                    Protect personal data in cloud environments by implementing
                    controls for data confidentiality, consent management,
                    transparency, and privacy safeguards for cloud service
                    customers.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>Asset Classification</span>
                    </li>
                    <li>
                      <span>Documentation</span>
                    </li>
                    <li>
                      <span>CE Marking</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">
                    GDPR, DPDP &amp; ISO 27701
                  </h3>
                  <p className="compliance-timeline-description">
                    Privacy-by-design for processing, data subject rights,
                    impact assessments, and cross-border data transfer
                    mechanisms.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>Privacy Controls</span>
                    </li>
                    <li>
                      <span>DPIA</span>
                    </li>
                    <li>
                      <span>Data Rights</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">
                    ISO 31000 Risk Framework
                  </h3>
                  <p className="compliance-timeline-description">
                    Enterprise risk management principles applied to system
                    including risk identification, analysis, evaluation, and
                    treatment strategies.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>Risk Strategy</span>
                    </li>
                    <li>
                      <span>Treatment Plans</span>
                    </li>
                    <li>
                      <span>Monitoring</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="compliance-timeline-item">
                <div className="compliance-timeline-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="compliance-timeline-content">
                  <h3 className="compliance-timeline-title">
                    Sector-Specific Requirements
                  </h3>
                  <p className="compliance-timeline-description">
                    Industry regulations including HIPAA, PCI-DSS, SOX,
                    financial services, healthcare AI, and critical
                    infrastructure compliance.
                  </p>
                  <ul className="compliance-timeline-tags">
                    <li>
                      <span>Industry Standards</span>
                    </li>
                    <li>
                      <span>Vertical Compliance</span>
                    </li>
                    <li>
                      <span>Audits</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iso-standards-aigrcai-governance-risk-compliance-thq-cta-engagement-section-elm cta-engagement-section">
        <div className="cta-engagement-container">
          <div className="iso-standards-aigrcai-governance-risk-compliance-thq-cta-engagement-card-elm cta-engagement-card">
            <div className="cta-engagement-icon">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="section-title">Ready to Achieve ISO Stanadard</h2>
            <p className="section-content">
              Partner with our certified experts to align your ISO standards,
              mitigate regulatory risks, and build a comprehensive governance
              framework.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
            <div className="cta-engagement-actions">
              <a href="#contact">
                <div className="btn-primary btn-xl btn">
                  <span>Schedule GRC Assessment</span>
                </div>
              </a>
            </div>
            <div className="cta-engagement-features">
              <div className="cta-feature">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>ISO  Expertise</span>
              </div>
              <div className="iso-standards-aigrcai-governance-risk-compliance-thq-cta-feature-elm2 cta-feature"></div>
              <div className="cta-feature">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Rapid Implementation</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="iso-standards-aigrcai-governance-risk-compliance-container4">
        <div className="iso-standards-aigrcai-governance-risk-compliance-container5">
          <Script
            html={`<style>
        @keyframes slideDown {from {opacity: 0;
transform: translateY(-8px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="iso-standards-aigrcai-governance-risk-compliance-container6">
        <div className="iso-standards-aigrcai-governance-risk-compliance-container7">
          <Script
            html={`<script defer data-name="iso-ai-grc-interactions">

</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ISOStandardsAIGRCAIGovernanceRiskCompliance
